module.exports = __webpack_public_path__ + "static/media/IMG_1206.db9fdc27.jpg";